import { BlogSection } from '@/types/blog';

export const einleitung: BlogSection = {
  id: 'einleitung',
  title: 'Einleitung',
  content: `
    <p>Meat Loaf sang einst: <em>"I would do anything for love, but I won't do that."</em></p>

    <p>Ein Paradox. Alles für die Liebe – aber nicht <em>das</em>?</p>

    <p>Jahrelang hielt ich das für ein lyrisches Rätsel. Bis ich Erich Fromm las.</p>

    <p>Fromm, Psychoanalytiker und Sozialphilosoph, schrieb 1956 <strong>„Die Kunst des Liebens"</strong> – ein Buch, das bis heute missverstanden wird. Nicht, weil es kompliziert ist. Sondern weil es radikal ist.</p>

    <p>Seine These: <strong>Liebe ist keine Emotion. Liebe ist eine Praxis.</strong></p>

    <p>Und diese Praxis entscheidet sich an einer fundamentalen Weggabelung: Haben oder Sein.</p>
  `
};
